export enum DowngradeType {
  BNBL = 'bnbl',
  // TODO: Tech debt: change package_change to change_package as it is more consistent from front end to backend to payments service.
  PACKAGE_CHANGE = 'package_change',
  PARTNER_CHANGE_PACKAGE = 'change_package',
  EXTEND_DATES = 'extend_dates',
  CHANGE_DATES_CHANNEL_MANAGED_HOTEL = 'change_dates_channel_managed_hotel',
  CHANGE_DATES_BEDBANK = 'change_dates_bedbank',
  CHANGE_DATES_AND_PACKAGE_BEDBANK = 'change_dates_and_package_bedbank',
  CHANGE_DATES_TACTICAL_AO_HOTEL = 'change_dates_tactical_ao_hotel',
}

export const getOrderDowngradeTypeLabel = (
  downgrade_type: DowngradeType | string,
  downgradeTo: boolean | null | undefined,
  downgradeFrom: boolean | null | undefined,
): string | undefined => {
  if (downgradeTo) {
    if (downgrade_type === DowngradeType.BNBL) {
      return 'Converted to BNBL';
    }
    if (
      [
        DowngradeType.PACKAGE_CHANGE,
        DowngradeType.PARTNER_CHANGE_PACKAGE,
        DowngradeType.EXTEND_DATES,
        DowngradeType.CHANGE_DATES_AND_PACKAGE_BEDBANK,
      ].includes(downgrade_type as DowngradeType)
    ) {
      return 'Upgraded to';
    }
    if (
      [
        DowngradeType.CHANGE_DATES_CHANNEL_MANAGED_HOTEL,
        DowngradeType.CHANGE_DATES_BEDBANK,
        DowngradeType.CHANGE_DATES_TACTICAL_AO_HOTEL,
      ].includes(downgrade_type as DowngradeType)
    ) {
      return 'Changed dates to';
    }
    return undefined;
  } else if (downgradeFrom) {
    if (downgrade_type === DowngradeType.BNBL) {
      return 'BNBL converted from';
    }
    if (
      [
        DowngradeType.PACKAGE_CHANGE,
        DowngradeType.PARTNER_CHANGE_PACKAGE,
        DowngradeType.EXTEND_DATES,
        DowngradeType.CHANGE_DATES_AND_PACKAGE_BEDBANK,
      ].includes(downgrade_type as DowngradeType)
    ) {
      return 'Upgraded from';
    }
    if (
      [
        DowngradeType.CHANGE_DATES_CHANNEL_MANAGED_HOTEL,
        DowngradeType.CHANGE_DATES_BEDBANK,
        DowngradeType.CHANGE_DATES_TACTICAL_AO_HOTEL,
      ].includes(downgrade_type as DowngradeType)
    ) {
      return 'Changed dates from';
    }
    return undefined;
  }
  return undefined;
};
